export default __webpack_public_path__ + "static/media/pos.017d71b5.svg";